export function getCurrentDateInSeconds() {
    return Math.floor(Date.now() / 1000).toString();
}